



























































































































































import { instanceToPlain, plainToInstance } from 'class-transformer'
import { cloneDeep } from 'lodash'
import { Component, Prop, Emit, Mixins, Watch } from 'vue-property-decorator';

import ModelSetter from "../../../Mixins/ModelSetter";
import {
  AvailableButtonsTypes
} from "../../../components/NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/logic/types";
import MessageEditorWithMediaData, {
  IMessageTemplate
} from '../../../components/NewMessageEditors/NewMessageEditorWithMedia/types';
import PageTitle from "../../../components/PageTitle.vue";
import NestedContent from '../../../components/Pi/components/NestedContent.vue';
import MessageEditorWithMediaInput
  from '../../../components/Pi/fields/NewMessageEditorWithMediaInput/MessageEditorWithMediaInput.vue';
import NumberInput from '../../../components/Pi/fields/NumberInput/NumberInput.vue';
import SwitchInput from '../../../components/Pi/fields/SwitchInput/SwitchInput.vue';
import TimeUnitInput from '../../../components/Pi/fields/TimeUnitInput/TimeUnitInput.vue';
import { BotFeedbackProtection, BotPmConfig } from "./types";

@Component({
  components: {
    PageTitle,
    SwitchInput,
    NumberInput,
    TimeUnitInput,
    MessageEditorWithMediaInput,
    NestedContent,
  }
})
export default class FeedbackSettings extends Mixins(ModelSetter) {
  @Prop() pmConfig!: BotPmConfig

  @Prop() bot!: { title: string, id: string }

  @Prop() editorButtons!: AvailableButtonsTypes

  @Emit()
  saveConfig() {
    return this.configCopy
  }

  @Watch('pmConfig', { deep: true })
  onPmConfigChange(config: BotPmConfig) {
    this.configCopy = cloneDeep(config)
  }

  configCopy: BotPmConfig | null = null

  get protectionMessage() {
    return plainToInstance(MessageEditorWithMediaData, this.configCopy!.protection.message)
  }

  set protectionMessage(value: IMessageTemplate) {
    if (this.configCopy) {
      this.configCopy.protection.message = instanceToPlain(value) as BotFeedbackProtection['message']
    }
  }

  get titleProps() {
    const key = 'field_feedback_settings'
    const helpMessageKey = `${ key }_help_message`

    return {
      'title': this.$t(`${ key }_title`, [ this.bot?.title ?? '' ]),
      'help-message': this.$te(helpMessageKey) ? this.$t(helpMessageKey, [ this.bot?.title ?? '' ]) : null
    }
  }

  created() {
    this.configCopy = cloneDeep(this.pmConfig)
  }
}
